module.exports = __webpack_public_path__ + "static/banner-707dbb7524e9a562c03d25d4244f3c6e.png";